import React from 'react'
import styled from 'styled-components'
import { ReactComponent as LockedIcon } from 'core-system/Icons/Locked/Locked.svg'
import palette from 'core-system/Themes/palette'
import Text from 'core-system/Text'

const Container = styled.div`
  background: linear-gradient(
    to bottom,
    ${palette.secondary.purple600},
    ${palette.primary.pink400}
  );
  border-radius: 0.5rem;
  padding: 0.625rem 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: fit-content;
`

const LockedBadge = ({ ...props }) => {
  return (
    <Container {...props}>
      <LockedIcon style={{ width: '1.25rem', height: '1.25rem' }} />
      <Text variant='action3' color={palette.white}>
        Feature Locked
      </Text>
    </Container>
  )
}

export default React.memo(LockedBadge)
